<template>
  <div :class="$style.container">
    <MCAPaymentsCustomTable
      :data="transactions"
      :empty-msg="$t('spendPage.noTransactionsAvailable')"
      :loading="fetchTransactionsRequest.isPending"
      bordered
      manrope
    >
      <template #row="slotProps">
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          show="createdAt"
          :label="() => $t('spendPage.date')"
          type="date"
          manrope
        />
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          :label="() => $t('spendPage.advanceType')"
          manrope
          capitalize
        >
          {{ advanceType(slotProps?.row) }}
        </MCAPaymentsCustomColumn>
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          :label="() => $t('spendPage.advanceId')"
          manrope
        >
          #{{
            slotProps?.row?.repaysAdvanceId || slotProps?.row?.fundsAdvanceId
          }}
        </MCAPaymentsCustomColumn>
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          :label="() => $t('spendPage.type')"
          manrope
        >
          {{ typeDisplayText(slotProps?.row?.type) }}
        </MCAPaymentsCustomColumn>
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          :label="() => $t('spendPage.description')"
          manrope
        >
          <a
            v-if="slotProps?.row?.childInvoiceId"
            href="#"
            @click.prevent="showDetailsPopup(slotProps?.row?.id)"
            >{{ slotProps?.row?.description }}</a
          >
          <span v-else>{{ slotProps?.row.description }}</span>
        </MCAPaymentsCustomColumn>
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          :label="() => $t('spendPage.status')"
          uppercase
          manrope
          :class="rowToStatusClass(slotProps?.row)"
        >
          {{ statusDisplayText(slotProps?.row.status) }}
        </MCAPaymentsCustomColumn>
        <MCAPaymentsCustomColumn
          v-if="userHasHadActiveMarketingAdvance"
          :row="slotProps?.row"
          show="cashbackAmountCents"
          :label="() => $t('spendPage.discountCredit')"
          type="money"
          manrope
          :class="rowToCashBackClass(slotProps?.row)"
        />
        <MCAPaymentsCustomColumn
          :row="slotProps?.row"
          show="amountCents"
          :label="() => $t('spendPage.amount')"
          type="money"
          manrope
        />
      </template>
    </MCAPaymentsCustomTable>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapRequestStatuses } from '@/utils/vuex-api-utils';
import { ADVANCE_SUBTYPES, ADVANCE_SUPRATYPES } from '@/data/advance-subtypes';
import MCAPaymentsCustomTable from '@/pages/mca/components/MCAPaymentsCustomTable.vue';
import MCAPaymentsCustomColumn from '@/pages/mca/components/MCAPaymentsCustomColumn.vue';

export default {
  components: {
    MCAPaymentsCustomTable,
    MCAPaymentsCustomColumn,
  },
  props: {
    transactions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    ...mapGetters(['activatedAdvancesBySubtype', 'supratypeById']),
    ...mapRequestStatuses({
      fetchTransactionsRequest: 'FETCH_TRANSACTIONS',
    }),
    userHasHadActiveMarketingAdvance() {
      return !!this.activatedAdvancesBySubtype?.unified?.length;
    },
  },
  methods: {
    rowToCashBackClass(row) {
      if (!row?.cashbackAmountCents) {
        return '';
      }

      if (row.cashbackAmountCents === '0') {
        return this.$style.pending;
      }

      return this.$style.green;
    },
    rowToStatusClass(row) {
      if (!row?.status) {
        return '';
      }
      return this.$style[row.status.replace('-', '_')];
    },
    statusDisplayText(status) {
      if (!status) {
        return undefined;
      }
      return this.$t(`common.transactionStatuses.${status}`) || status;
    },
    typeDisplayText(type) {
      if (type) {
        return this.$t(`common.tranactionTypes.${type}`);
      }
      return type;
    },
    advanceType(row) {
      const advanceId = row?.fundsAdvanceId || row?.repaysAdvanceId;
      const advanceType = this.supratypeById[advanceId];

      switch (advanceType) {
        case ADVANCE_SUPRATYPES.marketing:
          return this.$t('data.allAdvanceTypes.marketing');
        case ADVANCE_SUBTYPES.UNIFIED:
          return this.$t('data.allAdvanceTypes.marketing');
        case ADVANCE_SUBTYPES.MARKETING_FACEBOOK:
          return this.$t('data.allAdvanceTypes.marketing');
        case ADVANCE_SUBTYPES.VENTURES:
          return this.$t('data.allAdvanceTypes.ventures');
        case ADVANCE_SUBTYPES.INVENTORY:
          return this.$t('data.allAdvanceTypes.inventory');
        case ADVANCE_SUBTYPES.BNPL:
          return this.$t('data.allAdvanceTypes.bnpl');
        default:
          return this.$t('data.allAdvanceTypes.unknown');
      }
    },
  },
};
</script>

<style lang="less" module>
.container {
  border: 1px solid @color-grey-200;
  border-radius: 4px;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  background-color: @color-white;
}

.green {
  color: @color-success-400;
}
.pending {
  color: @medium-gray;
}
.in_transit {
  color: @medium-gray;
}
.failed {
  color: @color-danger-500;
}
.success {
  color: @color-success-400;
}
.cancelled {
  color: @color-danger-500;
}
.settled {
  color: @color-success-400;
}
.scheduled {
  color: @medium-gray;
}
</style>
